import * as Yup from "yup";
import dayjs from "dayjs";

// export const validateRowSchema = Yup.object().shape({
//     name: Yup
//         .string()
//         .required("Required"),
//     description: Yup
//         .string()
//         .required("Required"),
//     qty: Yup
//         .number()
//         .typeError("NUmber Only")
//         .required("Required")
//         .test(
//             "is-positive",
//             "Please enter a positive number",
//             (value) => value >= 0 && 1 / value !== -Infinity),
// })

export const validationSchema = Yup.object({
    docItemId: Yup
        .string()
        .required("Required"),
    rackId: Yup
        .string()
        .required("Required"),
    slotId: Yup
        .string()
        .required("Required"),
    code: Yup
        .string()
        .required("Required"),
    verifyQty: Yup.lazy((val) => {

        let maxQty = val?.maxQty? val.maxQty : 0

        let valueSchema;

        valueSchema = Yup
            .number("")
            .typeError("Invalid")
            // .min(parseFloat(minQty))
            .max(parseFloat(maxQty), `Max : ${maxQty}`)
            .positive("More than 0")
            .required("Required")

        return Yup.object().shape({
            value: valueSchema,
            maxQty: Yup.mixed().nullable().typeError("Invalid")
        })  

    }),
    verifyOut: Yup.lazy((val) => {

        let maxQty = val?.maxQty? val.maxQty : 0

        let valueSchema;

        valueSchema = Yup
            .number("")
            .typeError("Invalid")
            // .min(parseFloat(minQty))
            .max(parseFloat(maxQty), `Max : ${maxQty}`)
            .positive("More than 0")
            .required("Required")

        return Yup.object().shape({
            id: Yup
                .string()
                .required("Required"),
            value: valueSchema,
            maxQty: Yup.mixed().nullable().typeError("Invalid"),
        })

    }),

})

export const initialValues = {
    docItemId: "",
    itemName: "",
    rackId: "",
    slotId: "",
    code: "",
    verifyQty: {
        value: "0",
        maxQty: "0"
    },
    verifyOut: {
        // enableTrackBatch: false,
        id: "",
        customBatchNo: "",
        expiryDate: "",
        value: "0",
        maxQty: "0"
    }
}
